import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { TOrganization } from '~/features/organizations/models'
import queryKeys from '~/features/organizations/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

const useGetOrganization = (
  id: string,
  options?: Partial<UseQueryOptions<HttpServiceBaseResponse<TOrganization>>>,
) => {
  return useQuery({
    enabled: !!id,
    queryKey: queryKeys.organization(id),
    queryFn: () =>
      HttpService.get<TOrganization>({
        path: pathBuilder(EServerPath.organization, { id }),
      }),
    ...options,
  })
}

export default useGetOrganization
